import { subscriptionCardSmallIF } from '../components/SubscriptionCard/subscriptionCardSmallIF'

export const entityAccountHowItWorks: Array<{
  title: string
  content: string
}> = [
  {
    title: `Choose your plan`,
    content: `For larger firms, the 60-profile plan may be ideal, while smaller practices may find 
                    the 15- or 20-profile plans more suited to their requirements.`,
  },
  {
    title: `Set up your profile`,
    content: `When you've selected your plan, you can create or claim your profile.`,
  },
  {
    title: `Customise and publish`,
    content: `Use our Lawyer Portal to complete your profile, upload content, and publish articles 
                    or podcasts. Ensure your profile is client-ready with our verification options and 
                    profile management tools.`,
  },
  {
    title: `Manage and grow`,
    content: `With access to booking analytics, content publishing, and automated scheduling, you 
                    can track your profile's performance and make adjustments as needed. For example, y
                    ou can scale your presence by adding profile add-ons as your team grows. Or if someone 
                    joins from another chambers or firm, their existing profile can be transferred to your 
                    firm page. If someone leaves to join another firm/chambers, they can transfer their 
                    profile to their new firm/chambers.`,
  },
]

export const entityAccountFeatures: {
  title: string
  features: Array<{ text: string; additionalInfo: string }>
}[] = [
  {
    title: 'Premium Profile and Management Tools',
    features: [
      {
        text: `Premium chamber's profile: Showcase your firm or chamber with a comprehensive profile that 
            attracts prospective clients and elevates your brand.`,
        additionalInfo: ``,
      },
      {
        text: `Account booking analytics: Gain insights into your profile’s performance and booking trends 
            to optimise engagement strategies.`,
        additionalInfo: ``,
      },
      {
        text: `Account, event log, and profile management: Monitor activities, manage bookings, and edit 
            profiles seamlessly from your dashboard.`,
        additionalInfo: ``,
      },
    ],
  },
  {
    title: 'Verified and Prioritised Listings',
    features: [
      {
        text: `Verified Profile and ID Verification: Legal Utopia verifies lawyer profiles, boosting 
            client trust and visibility.`,
        additionalInfo: ``,
      },
      {
        text: `Priority Profile Ranking: Boost your ranking on the Find a Lawyer service, enhancing your
            discoverability among potential clients.`,
        additionalInfo: ``,
      },
      {
        text: `Dedicated Web Landing Pages: Each individual profile gets a unique web page, and chambers/firms
            can also create a dedicated landing page to consolidate their team under one banner.`,
        additionalInfo: ``,
      },
    ],
  },
  {
    title: 'Content Publishing and Client Engagement',
    features: [
      {
        text: `Client Reviews Management: Manage client reviews directly on the platform to showcase your 
            strengths and your reputation.`,
        additionalInfo: ``,
      },
      {
        text: `Personalised Website Placements: Get premium placement opportunities for greater visibility 
            on Legal Utopia's platform.`,
        additionalInfo: ``,
      },
      {
        text: `Content Publishing Options: Publish one Legal Utopia Podcast per quarter and one blog or
            article per account per day, providing thought leadership and engaging with potential clients.`,
        additionalInfo: ``,
      },
    ],
  },
  {
    title: 'Booking and Scheduling Automation',
    features: [
      {
        text: `Automated Scheduling and Calendar Management: Streamline your booking process with automated 
            tools, allowing clients to book directly via your profile with real-time availabilit`,
        additionalInfo: ``,
      },
      {
        text: `Bookings and Profile Management: Manage your professional schedule and profile seamlessly, 
            ensuring clients have the latest information about your availability and services.`,
        additionalInfo: ``,
      },
    ],
  },
]

export const entityAccountSubscriptions: Array<subscriptionCardSmallIF> = [
  {
    title: '15x profiles',
    subTitle: 'Premium member',
    amount: '£1,569',
    vatAddition: true,
    occurence: 'per month',
    additionalAmount: '£3,500',
    additionalAmountVat: true,
    additionalOccurence: 'per annum',
    buttonLabel: 'Get started',
    buttonLink: '',
  },
  {
    title: '20x profiles',
    subTitle: 'Premium member',
    amount: '£1,569',
    vatAddition: true,
    occurence: 'per month',
    additionalAmount: '£11,500',
    additionalAmountVat: true,
    additionalOccurence: 'per annum',
    buttonLabel: 'Get started',
    buttonLink: '',
  },
  {
    title: '60x profiles',
    subTitle: 'Premium member',
    amount: '£1,569',
    vatAddition: true,
    occurence: 'per month',
    additionalAmount: '£19,500',
    additionalAmountVat: true,
    additionalOccurence: 'per annum',
    buttonLabel: 'Get started',
    buttonLink: '',
  },
  {
    title: '1x Profile Add-on',
    subTitle: 'Premium member',
    amount: '£650',
    vatAddition: true,
    occurence: 'per annum',
    buttonLabel: 'Get started',
    buttonLink: '',
  },
]
